/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

//TODO:
require('./src/styles/global.scss');
const React = require('react');
const initOsanoConsentReload = require('./src/tools/osanoConsentReload').default;
const { initConsent } = require('./src/utils/fullstory/consent');

let runInIframe = false;

exports.wrapRootElement = ({ element }) => <React.StrictMode>{element}</React.StrictMode>;

exports.onInitialClientRender = () => {
  // [DEMO-ONLY-START] Spotlight + click-inspect receiver for the decoration accelerator deck
  function _fsEnsureStyles() {
    if (document.getElementById('fs-spotlight-styles')) return;
    const s = document.createElement('style');
    s.id = 'fs-spotlight-styles';
    s.textContent = [
      '[data-fs-spotlit]{outline:3px solid #07c799!important;outline-offset:4px;',
      'box-shadow:0 0 0 8px rgba(7,199,153,0.12)!important;border-radius:4px;',
      'animation:fs-spotlight-pulse 1.8s ease-in-out 3;}',
      '@keyframes fs-spotlight-pulse{0%,100%{box-shadow:0 0 0 4px rgba(7,199,153,0.18);}50%{box-shadow:0 0 0 14px rgba(7,199,153,0);}}',
      '[data-fs-hovered]{outline:2px dashed rgba(7,199,153,0.55)!important;cursor:crosshair!important;}',
      '.fs-spotlight-badge{position:fixed;background:#081f1f;',
      'border:1px solid #1a5050;border-left:3px solid #07c799;border-radius:8px;',
      'padding:12px 16px;z-index:99999;font-family:"SF Mono","Fira Code",monospace;',
      'font-size:11px;color:#8ec8bf;line-height:1.7;max-width:320px;pointer-events:none;',
      'box-shadow:0 8px 32px rgba(0,0,0,0.5);animation:fs-badge-in 0.15s ease;}',
      '@keyframes fs-badge-in{from{opacity:0;transform:scale(0.95);}to{opacity:1;transform:none;}}',
      '.fs-spotlight-badge .fa{color:#07c799;}.fs-spotlight-badge .fv{color:#85e89d;}',
    ].join('');
    document.head.appendChild(s);
  }

  function _fsShowBadge(el) {
    document.querySelector('.fs-spotlight-badge')?.remove();
    const SKIP = new Set(['data-gatsby-image-ssr', 'data-fs-spotlit', 'data-fs-hovered']);
    const attrs = [...el.attributes].filter((a) => /^(data-|aria-)/.test(a.name) && !SKIP.has(a.name)).slice(0, 10);
    if (!attrs.length) return;
    const badge = document.createElement('div');
    badge.className = 'fs-spotlight-badge';
    badge.innerHTML = attrs
      .map((a) => `<div><span class="fa">${a.name}</span>=<span class="fv">"${a.value.slice(0, 55)}"</span></div>`)
      .join('');
    document.body.appendChild(badge);
    // Position near element — right side preferred, fall back to left
    const rect = el.getBoundingClientRect();
    const bw = badge.offsetWidth || 320;
    const bh = badge.offsetHeight || 160;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let left = rect.right + 14;
    if (left + bw > vw - 8) left = Math.max(8, rect.left - bw - 14);
    let top = rect.top;
    if (top + bh > vh - 8) top = Math.max(8, vh - bh - 8);
    badge.style.top = top + 'px';
    badge.style.left = left + 'px';
  }

  window.addEventListener('message', (e) => {
    const type = e.data?.type;
    if (!type || !type.startsWith('fs-')) return;
    _fsEnsureStyles();

    if (type === 'fs-spotlight') {
      document.querySelectorAll('[data-fs-spotlit]').forEach((el) => el.removeAttribute('data-fs-spotlit'));
      document.querySelector('.fs-spotlight-badge')?.remove();
      clearTimeout(window._fsSpotlightTimer);
      const el = document.querySelector(e.data.selector);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.setAttribute('data-fs-spotlit', 'true');
      _fsShowBadge(el);
      window._fsSpotlightTimer = setTimeout(() => {
        el.removeAttribute('data-fs-spotlit');
        document.querySelector('.fs-spotlight-badge')?.remove();
      }, 5000);
    }

    // Patch FS to forward trackEvent to the parent presentation window
    // (event bridge only — no hover/click interception)
    function _fsPatchEvents() {
      if (window._fsOrigFn || typeof window.FS !== 'function') return;
      window._fsOrigFn = window.FS;
      const patched = function () {
        const args = [...arguments];
        if (args[0] === 'trackEvent' && args[1]?.name) {
          try {
            window.parent.postMessage(
              {
                type: 'fs-event-fired',
                name: args[1].name,
                properties: args[1].properties || {},
              },
              '*'
            );
          } catch (_) {}
        }
        return window._fsOrigFn.apply(this, args);
      };
      Object.assign(patched, window._fsOrigFn);
      patched.q = window._fsOrigFn.q;
      window.FS = patched;
    }

    if (type === 'fs-event-patch') {
      _fsPatchEvents();
    }

    if (type === 'fs-inspect-enable') {
      if (window._fsInspectEnabled) return;
      window._fsInspectEnabled = true;
      _fsPatchEvents();

      window._fsHoverHandler = (ev) => {
        document.querySelectorAll('[data-fs-hovered]').forEach((el) => el.removeAttribute('data-fs-hovered'));
        // Walk up to nearest decorated ancestor so outlines aren't clipped by
        // GatsbyImage's overflow:hidden on the inner <img> element.
        let el = ev.target;
        while (el && el !== document.body) {
          if ([...el.attributes].some((a) => /^data-fs-/.test(a.name) || a.name === 'data-component')) break;
          el = el.parentElement;
        }
        if (el && el !== document.body) el.setAttribute('data-fs-hovered', 'true');
      };
      window._fsClickHandler = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        let el = ev.target;
        while (el && el !== document.body) {
          if ([...el.attributes].some((a) => /^data-fs-/.test(a.name) || a.name === 'data-component')) break;
          el = el.parentElement;
        }
        if (!el || el === document.body) return;
        document.querySelectorAll('[data-fs-spotlit],[data-fs-hovered]').forEach((e) => {
          e.removeAttribute('data-fs-spotlit');
          e.removeAttribute('data-fs-hovered');
        });
        clearTimeout(window._fsSpotlightTimer);
        el.setAttribute('data-fs-spotlit', 'true');
        _fsShowBadge(el);
        window._fsSpotlightTimer = setTimeout(() => {
          el.removeAttribute('data-fs-spotlit');
          document.querySelector('.fs-spotlight-badge')?.remove();
        }, 5000);
      };
      document.addEventListener('mouseover', window._fsHoverHandler);
      document.addEventListener('click', window._fsClickHandler, true);
    }

    if (type === 'fs-inspect-toggle') {
      const next = window._fsInspectEnabled ? { type: 'fs-inspect-disable' } : { type: 'fs-inspect-enable' };
      window.dispatchEvent(new MessageEvent('message', { data: next }));
      return;
    }

    if (type === 'fs-inspect-disable') {
      window._fsInspectEnabled = false;
      document.removeEventListener('mouseover', window._fsHoverHandler);
      document.removeEventListener('click', window._fsClickHandler, true);
      document.querySelectorAll('[data-fs-hovered],[data-fs-spotlit]').forEach((el) => {
        el.removeAttribute('data-fs-hovered');
        el.removeAttribute('data-fs-spotlit');
      });
      document.querySelector('.fs-spotlight-badge')?.remove();
      window._fsHoverHandler = window._fsClickHandler = null;
      // Keep FS patched so event toast continues to work with inspect off
    }
  });
  // [DEMO-ONLY-END]

  if (process.env.GATSBY_ENABLE_NOBLE === 'true') {
    const iframe = document.createElement('iframe');
    iframe.src =
      'https://buyers.thatsnoble.com/conversion?tenant-id=7880526e-3d0a-4dcd-a795-a5aacc49f92f&conversion-type-id=cc4ac086-94d3-422d-b43f-4adbcb741cdf';
    iframe.id = 'noble-conversion-tag';
    iframe.style.display = 'none';
    iframe.width = '0';
    iframe.height = '0';
    iframe.setAttribute('title', 'Noble Conversion');
    iframe.setAttribute('aria-hidden', 'true');
    document.body.appendChild(iframe);
  }
  if (typeof window !== 'undefined') {
    window['_fs_run_in_iframe'] = runInIframe;
    const scrpt = document.createElement('script');
    scrpt.src = 'https://static.claydar.com/init.v1.js?id=cBV9N168OX';
    scrpt.id = 'Clay';
    scrpt.async = true;

    document.body.appendChild(scrpt);
  }

  // Re-run the consent-gated tags when a visitor saves a new choice.
  initOsanoConsentReload();

  // Holistic mode only: pause/resume Fullstory capture with MARKETING
  // consent. Off by default — the same GATSBY_FS_CONSENT_HOLISTIC flag
  // that sets _fs_capture_on_startup=false in gatsby-ssr.js, so the
  // snippet and this bridge can't disagree about who starts capture.
  if (process.env.GATSBY_FS_CONSENT_HOLISTIC === 'true') {
    initConsent();
  }
};

exports.shouldUpdateScroll = () => {
  if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
    return false;
  }
  window.scrollTo(0, 0);

  return false;
};

const { setAnonymousContext, readBrowserContext } = require('./src/utils/fullstory/identification');
const { validateCuaPairing } = require('./src/utils/fullstory/cua');

exports.onRouteUpdate = ({ location }) => {
  if (location.pathname.indexOf('signup') > -1 && location.search.includes('freemium')) {
    window.location.replace('/fullstoryfree/');
  }
  const ctx = readBrowserContext();
  if (ctx) setAnonymousContext(ctx);

  if (process.env.NODE_ENV !== 'production') {
    // Let React finish rendering before scanning for pairing violations.
    setTimeout(() => validateCuaPairing(), 500);
  }
};
